<template>
  <div class="side-menu-element" :class="{ 'is-collapsed': isLittle }">
    <router-link
      class="menu_element_block flex items-center align-middle rounded-lg transition-all duration-200"
      :to="'/' + path"
      :title="isLittle ? menu : ''"
    >
      <span
        class="avtive_position"
        :class="{ 'is-active-position-little': isLittle }"
      ></span>
      <div class="icon-wrapper">
        <icon
          :data="icon"
          width="22"
          height="22"
          class="menu_element_icon"
          original
        />
      </div>
      <div
        v-if="!isLittle"
        class="menu_element ml-3 font-medium lg:text-sm xl:text-base 2xl:text-lg"
      >
        {{ menu }}
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "side-menu-element",
  props: {
    menu: String,
    icon: [String, Object],
    path: String,
    isLittle: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/style/sass/variables";

.side-menu-element {
  padding: 0 12px;
  &.is-collapsed {
    padding: 0;
    display: flex;
    justify-content: center;
  }
}

.menu_element_block {
  padding: 12px;
  margin: 4px 0;
  position: relative;
  color: #5c5e64;
  cursor: pointer;
  width: 100%;
  display: flex;
  align-items: center;

  .icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
    min-width: 24px;
    position: relative;
  }

  .menu_element {
    width: 100%;
    z-index: 2;
    position: relative;
    transition: color 0.2s;
  }

  .avtive_position {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 100%;
    width: 100%;
    z-index: 1;
    visibility: hidden;
    transition: all 0.2s;
  }

  &:hover {
    background: rgba(251, 219, 108, 0.08);
  }

  &.router-link-active {
    color: #000 !important;
    .avtive_position {
      visibility: visible;
      background: #fbdb6c;
      border-radius: 8px;
    }
  }
}

/* Collapsed state adjustments */
.is-collapsed {
  .menu_element_block {
    justify-content: center;
    padding: 12px 0;
    width: 48px;
    height: 48px;
    border-radius: 12px;

    .avtive_position {
      width: 4px !important;
      left: -12px;
      border-radius: 0 4px 4px 0;
      height: 24px;
      z-index: 1;
    }

    &.router-link-active {
      background: rgba(251, 219, 108, 0.15);
      .avtive_position {
        visibility: visible;
        background: #fbdb6c;
      }
    }
  }
}
</style>
